<template>
  <div class="home-container">
    <TablesList :tableListArray="tableListArray" />

    <div v-if="$route.name !== 'cashier-checkout'" class="home-header-wrap">
      <div class="home-header">
        <div class="hh-right">
          <div class="hh-icon">
            <v-icon size="24" color="white">mdi-view-dashboard</v-icon>
          </div>
          <div>
            <h1 class="hh-title">משמחי לב</h1>
            <p class="hh-desc">מערכת ניהול | {{ greeting }}</p>
          </div>
        </div>
        <div class="hh-date">
          <v-icon size="14" color="#90A4AE" class="ml-1">mdi-calendar-today</v-icon>
          {{ todayDate }}
        </div>
      </div>
    </div>

    <!-- Dashboard Grid -->
    <div class="dashboard-grid" v-if="$route.name === 'home'">
      <v-row>
        <v-col v-for="(table, index) in tableListArray" :key="index" cols="12" sm="6" md="4" lg="3">
          <div class="dash-card" @click="navigateToTable(table.routeName)">
            <div class="dc-body">
              <div class="dc-icon-wrap" :style="{ background: getCardGradient(index) }">
                <v-icon size="32" color="white">{{ table.icon }}</v-icon>
              </div>
              <h3 class="dc-name">{{ table.name }}</h3>
            </div>
            <div class="dc-footer">
              <span class="dc-link" :style="{ color: getCardColor(index) }">
                <v-icon size="16" :color="getCardColor(index)">mdi-arrow-left</v-icon>
                פתח
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Router View with Transition -->
    <v-fade-transition mode="out-in">
      <router-view></router-view>
    </v-fade-transition>
  </div>
</template>

<script>
import TablesList from '@/components/TablesList'
import Auth from '@/services/auth.service.js'

export default {
  name: 'home',
  components: { TablesList },
  data: () => ({
    loading: false,
    tableStats: {},
    tableListArray: [
      { name: "משתמשים", icon: "mdi-account-group", routeName: "users" },
      { name: "לקוחות", icon: "mdi-account", routeName: "customers" },
      { name: "מלאי", icon: "mdi-warehouse", routeName: "inventory" },
      { name: "הזמנות", icon: "mdi-cart", routeName: "orders" },
      { name: "החלפה והחזרה", icon: "mdi-swap-horizontal", routeName: "exchanges" },
      { name: "דוחות", icon: "mdi-chart-bar", routeName: "reports" },
      { name: "חפק אונליין", icon: "mdi-chart-line", routeName: "online-dashboard" },
      { name: "קופה", icon: "mdi-cash-register", routeName: "cashier" },
      { name: "כניסה והדפסה", icon: "mdi-login", routeName: "entry" },
      { name: "לפני כניסה", icon: "mdi-door-open", routeName: "pre-entry" },
      { name: "הגדרות שעות חלוקה", icon: "mdi-clock-outline", routeName: "distribution" },
      { name: "מלאי טלפוני", icon: "mdi-phone", routeName: "phone-inventory" },
      { name: "מסמכי מס", icon: "mdi-file-certificate-outline", routeName: "tax-documents" },
      { name: "קהילות", icon: "mdi-account-group-outline", routeName: "communities" }
    ],
  }),
  computed: {
    todayDate() {
      const d = new Date();
      return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    },
    greeting() {
      const h = new Date().getHours();
      if (h < 12) return 'בוקר טוב';
      if (h < 17) return 'צהריים טובים';
      if (h < 21) return 'ערב טוב';
      return 'לילה טוב';
    },
  },
  methods: {
    getCardGradient(index) {
      const gradients = [
        'linear-gradient(135deg, #2196F3, #1565C0)',
        'linear-gradient(135deg, #4CAF50, #2E7D32)',
        'linear-gradient(135deg, #FF9800, #F57C00)',
        'linear-gradient(135deg, #7C4DFF, #4527A0)',
        'linear-gradient(135deg, #E91E63, #AD1457)',
        'linear-gradient(135deg, #00BCD4, #00838F)',
        'linear-gradient(135deg, #FF5722, #D84315)',
        'linear-gradient(135deg, #3F51B5, #283593)',
        'linear-gradient(135deg, #009688, #00695C)',
        'linear-gradient(135deg, #795548, #4E342E)',
        'linear-gradient(135deg, #607D8B, #37474F)',
        'linear-gradient(135deg, #F44336, #C62828)',
      ];
      return gradients[index % gradients.length];
    },
    getCardColor(index) {
      const colors = ['#1565C0', '#2E7D32', '#F57C00', '#4527A0', '#AD1457', '#00838F', '#D84315', '#283593', '#00695C', '#4E342E', '#37474F', '#C62828'];
      return colors[index % colors.length];
    },
    navigateToTable(tableName) {
      const table = this.tableListArray.find(t => t.routeName === tableName);
      if (table && table.routeName) {
        this.$router.push({ name: table.routeName });
      }
    },
  },
  created() {
    let role = Auth.getUserRole();
    if (role === "customers") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "לקוחות")
    } else if (role === "reports") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "דוחות")
    } else if (role === "onlineDashborad") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "חפק אונליין")
    } else if (role === "products") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "מלאי")
    } else if (role === "orders") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "הזמנות")
    } else if (role === "exchanges") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "החלפה והחזרה")
    } else if (role === "cashRegister") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "קופה")
    } else if (role === "enterToShop") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "לפני כניסה")
    } else if (role === "enterAndPrint") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "כניסה והדפסה")
    } else if (role === "enterAndPrintWithoutForce") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "כניסה והדפסה")
    } else if (role === "settings") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "הגדרות שעות חלוקה")
    } else if (role === "phoneLimitStock") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "מלאי טלפוני")
    } else if (role === "enterAndPrintAndExchanges") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "כניסה והדפסה" || table.name === "החלפה והחזרה")
    } else if (role === "customersAndOrders") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "לקוחות" || table.name === "הזמנות");
    } else if (role === "communities") {
      this.tableListArray = this.tableListArray.filter(table => table.name === "קהילות")
    } else if (role === "allExceptUsers") {
      this.tableListArray = this.tableListArray.filter(table => table.name !== "משתמשים")
    }
    this.tableListArray.unshift({
      name: "ראשי",
      icon: "mdi-home",
      routeName: "home"
    })
  },
}
</script>

<style lang="scss" scoped>
.home-container {
  min-height: 100vh;
}

/* HEADER */
.home-header-wrap {
  padding: 0 1rem;
  margin-bottom: .5rem;
}

.home-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: .75rem 1.15rem;
}

.hh-right {
  display: flex;
  align-items: center;
  gap: .75rem;
}

.hh-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #2196F3, #1565C0);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(33, 150, 243, .25);
}

.hh-title {
  font-size: 1.15rem;
  font-weight: 800;
  color: #1a2b3c;
  margin: 0;
}

.hh-desc {
  font-size: .75rem;
  color: #90A4AE;
  margin: 0;
}

.hh-date {
  font-size: .75rem;
  color: #90A4AE;
  font-weight: 500;
  display: flex;
  align-items: center;
}

/* DASHBOARD GRID */
.dashboard-grid {
  padding: .5rem 1rem;
}

.dash-card {
  background: white;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  cursor: pointer;
  transition: all .25s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 28px rgba(0, 0, 0, .08);
    border-color: #d0d9e2;
  }

  &:active {
    transform: translateY(-1px);
  }
}

.dc-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.75rem 1rem 1.25rem;
  gap: .85rem;
}

.dc-icon-wrap {
  width: 62px;
  height: 62px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .12);
  transition: transform .25s;

  .dash-card:hover & {
    transform: scale(1.1);
  }
}

.dc-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a2b3c;
  text-align: center;
  margin: 0;
}

.dc-footer {
  border-top: 1px solid #f1f5f9;
  padding: .6rem 1rem;
  display: flex;
  justify-content: center;
}

.dc-link {
  display: flex;
  align-items: center;
  gap: .25rem;
  font-size: .8rem;
  font-weight: 600;
  opacity: .6;
  transition: opacity .2s;

  .dash-card:hover & {
    opacity: 1;
  }
}

/* RESPONSIVE */
@media (max-width: 600px) {
  .dashboard-grid {
    padding: .5rem .75rem;
  }

  .dc-body {
    padding: 1.25rem .75rem 1rem;
  }

  .dc-icon-wrap {
    width: 52px;
    height: 52px;
    border-radius: 14px;
  }

  .dc-name {
    font-size: .9rem;
  }

  .home-header-wrap {
    padding: 0 .75rem;
  }
}

@media (min-width: 1264px) {
  .dashboard-grid {
    padding: .5rem 2rem;
  }

  .home-header-wrap {
    padding: 0 2rem;
  }
}
</style>